import { IncidentIcon, RiskZonesIcon, SafetyIcon, SpeedingsIcon } from "@l2r-front/l2r-icons"

import { L2rAppSafety } from "../../app"

import { ProjectContextProvider } from "../contexts/ProjectContext"
import { getModulesBreadcrumb } from "../utils/getModulesBreadcrumb"

import { I18N_NAMESPACE } from "./i18n"
import { MODULE_INCIDENTS, MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "./modules"

export const APP_SAFETY = "safety"

export const appSafety = {
    index: 3,
    color: "cta-bg/cta-bg-primary",
    component: <L2rAppSafety />,
    icon: SafetyIcon,
    desktopCustomLayoutRoutes: [`/${APP_SAFETY}/${MODULE_INCIDENTS}/:eventId/analysis`],
    externalContexts: <ProjectContextProvider />,
    i18nNamespace: I18N_NAMESPACE,
    label: "app.label",
    modules: {
        risk_zones: {
            index: 0,
            icon: RiskZonesIcon,
            id: "RISK_ZONE",
            label: "app.modules.riskZones",
            path: MODULE_RISK_ZONES,
            getModulesBreadcrumb,
        },
        speedings: {
            index: 1,
            icon: SpeedingsIcon,
            id: "SPEED_LIMIT",
            label: "app.modules.speedings",
            path: MODULE_SPEEDINGS,
            getModulesBreadcrumb,
        },
        incidents: {
            index: 2,
            icon: IncidentIcon,
            id: "INCIDENTS",
            label: "app.modules.incidents",
            hidden: true,
            path: MODULE_INCIDENTS,
            getModulesBreadcrumb,
        },
    },
    path: APP_SAFETY,
}